import React, {useState, useEffect} from 'react';
import TitleArea from './titlearea';
import Footer from './footer';
import SocialButtons from './socialbuttons';

const {prefixCSS} = polyphony.css;

const styles = {
    headerbar: prefixCSS({
        top: 0,
        width: "100%",
        display: "flex",
        zIndex: 100,
        height: 100,
        position: 'absolute',
        backgroundColor: 'transparent',
        justifyContent: "space-between"
    }),
    logo: prefixCSS({
        objectFit: 'fit',
        height: '100%',
        boxSizing: 'border-box',
        marginLeft: 15,
        width: 160
    }),
    logoWrapper: prefixCSS({
        height: '100%',
        display: 'flex'
    }),
    link: prefixCSS({
        fontWeight: 600,
        fontSize: 40,
        fontFamily: 'Poppins, sans-serif',
        margin: 10,
        textAlign: 'center',
        lineHeight: 1.25
    }),
    overlay: prefixCSS({
        position: 'fixed',
        zIndex: 1000,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    })
};

const HeaderBar = () => {
    const { image, items } = polyphony.useState(({header_bar, menus}) => ({
        items: menus['navigation-menu'].items,
        image: header_bar.image
    }));

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
            document.body.style.height = "100%";
        } else {
            document.body.style.overflow = "";
            document.body.style.height = "";
        }
    }, [open]);

    const toggleOpen = () => setOpen(!open);

    const {Image} = polyphony.components.generic;

    return (
        <div style={styles.headerbar}>
            <a href="/" style={styles.logoWrapper}>
                <Image media={image} style={styles.logo} />
            </a>
            {open &&
            <div className="polyphony-hamburger-overlay-menu" style={styles.overlay} onClick={toggleOpen}>
                {items.map(({title, url}, idx) =>
                <a key={idx} style={styles.link} href={url} onClick={toggleOpen}>{title}</a>)}
                <SocialButtons style={{paddingTop: 30, boxSizing: 'border-box'}} />
            </div>}
            <a onClick={toggleOpen}
               style={{paddingRight: 20,
                       display: 'flex',
                       alignItems: 'center',
                       height: '100%',
                       cursor: 'pointer',
                       zIndex: open ? 1001 : undefined}}>
                <div className={`hamburger hamburger--emphatic${open ? ' is-active' : ''}`}>
                  <div className="hamburger-box">
                    <div className="hamburger-inner" />
                  </div>
                </div>
            </a>
        </div>
    );
};

const ContentWrapper = ({children}) => {
  return <>
      <HeaderBar />
      <div style={{display: "flex", flexFlow: 'column nowrap', minHeight: '100vh'}}>
        <div style={{flexGrow: 2, display: 'flex', flexFlow: 'column nowrap'}}>
            <TitleArea />
            {React.Children.map(children, c => React.cloneElement(c, {style: {...c.style, flexGrow: 1}}))}
        </div>
        <Footer />
      </div>
  </>;
};

export default ContentWrapper;

